import { lazy, Suspense } from 'react';
import { ResourcePaneSkeleton } from 'v5/features/resources/pane/ResourcePaneSkeleton';

const NewResourcePane = lazy(
  () => import('v4/pages/resources/pane/ResourcePane')
);

export default props => {
  return (
    <Suspense fallback={<ResourcePaneSkeleton />}>
      <NewResourcePane {...props} />
    </Suspense>
  );
};
